import type { GuardianRelationshipStatus } from "../../types/guardianTypes";

export const guardianStatusPillClassName: Record<GuardianRelationshipStatus, string> = {
  ACTIVE: "border-emerald-200 bg-emerald-50 text-emerald-800",
  PENDING: "border-amber-200 bg-amber-50 text-amber-800",
  REMOVED: "border-slate-200 bg-slate-100 text-slate-700",
};

export const scrollablePanelClassName = (count: number) =>
  count > 3 ? "mt-6 grid max-h-[28rem] gap-4 overflow-y-auto pr-2" : "mt-6 grid gap-4";
